import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import InvoiceApprovalHomepage from "./InvoiceApprovalCards/InvoiceApprovalHomepage";

const tabs = ["Invoice Requests"];

const InvoiceApprovalTab = () => {
    const [_, setSearchParams] = useSearchParams();
    return (
        <div>
            <section>
                <header className="flex px-[3.75rem] items-center justify-between py-5">
                    <div>
                        <h1 className="text-[#49484C] font-bold text-[2rem]">Escalated Invoices</h1>
                    </div>
                </header>

                {/* table  */}
                <main>
                    <Tab.Group>
                        <Tab.List className="border-b-[1px] shadow-md border-b-[rgba(0, 0, 0, 0.10)] mb-[1.16rem] px-[3.75rem] mt-6">
                            {tabs.map((item: string) => (
                                <Tab key={item} as={Fragment}>
                                    {({ selected }: { selected: boolean }) => (
                                        <div
                                            onClick={() => {
                                                setSearchParams({
                                                    pageIndex: "1",
                                                    pageSize: "10",
                                                });
                                            }}
                                            className={`relative inline-block cursor-pointer -bottom-[1px] px-4 py-3 font-semibold text-sm  border-b-2  not-italic  hover:border-b-[#586AF5] hover:text-[#586af5] focus:outline-none ${selected ? "text-[#586af5] border-b-[#586AF5]" : "text-[rgba(0,0,0,0.4)] border-b-transparent"
                                                }`}
                                        >
                                            {item}
                                        </div>
                                    )}
                                </Tab>
                            ))}
                        </Tab.List>

                        <Tab.Panels>
                            <Tab.Panel className="px-[3.75rem]">
                                <InvoiceApprovalHomepage />
                            </Tab.Panel>
                        </Tab.Panels>
                    </Tab.Group>
                </main>
            </section>
        </div>
    );
};

export default InvoiceApprovalTab;
